<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-3" lazy>
        <b-tab title="Звернення читача" active>
          <enable-actions-form></enable-actions-form>
        </b-tab>
        <b-tab title="Налаштування кількість днів видачі книг" to="#examples" :active="$route.hash === '#examples'">
          <examples></examples>
        </b-tab>
        <b-tab title="Підписки" to="#subscriptions" :active="$route.hash === '#subscriptions'">
          <subscriptions-form></subscriptions-form>
        </b-tab>
        <b-tab title="Віджети" to="#widgets" :active="$route.hash === '#widgets'">
          <widgets></widgets>
        </b-tab>
        <b-tab title="Зовнішні каталоги" to="#servers" :active="$route.hash === '#servers'">
          <servers></servers>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>

  import Examples from "./Examples";
  import EnableActionsForm from "./EnableActionsForm";
  import SubscriptionsForm from "./SubscriptionsForm";
  import Widgets from "./Widgets";
  import Servers from "./Servers";

  export default {
    name: "Index",
    components:{
      Examples,
      EnableActionsForm,
      SubscriptionsForm,
      Widgets,
      Servers,
    }
  }
</script>

<style scoped>

</style>